import React from 'react';

import ImprovedHero from '../components/ImprovedHero.tsx';
import FeaturedProperties from '../components/FeaturedProperties.tsx';
import Services from '../components/Services.tsx';

const Home: React.FC = () => {
  return (
    <div className="min-h-screen">
      <ImprovedHero />
      <FeaturedProperties />
      <Services />
    </div>
  );
};

export default Home;